// src/components/FacebookPixelWatcher.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const FacebookPixelWatcher = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
      });
      console.log('[FacebookPixel] PageView fired:', window.location.href);
    } else {
      console.warn('[FacebookPixel] fbq not ready');
    }
  }, [location.pathname]);

  return null;
};

export default FacebookPixelWatcher;
